import React, { useCallback, useEffect, useRef, useState } from "react";
import { Image as ImageIcon, Upload, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, API, formatApiError } from "@/lib/api";

export default function PageLogoManager({ title, flagKey, updatedKey, serveUrl, uploadUrl, testid }) {
  const [present, setPresent] = useState(false);
  const [updatedAt, setUpdatedAt] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/settings");
      setPresent(!!res.data[flagKey]);
      setUpdatedAt(res.data[updatedKey] || "");
    } catch (e) {
      /* ignore */
    }
  }, [flagKey, updatedKey]);

  useEffect(() => {
    load();
  }, [load]);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      await api.post(uploadUrl, fd);
      toast.success("Logo atualizada!");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setUploading(false);
    }
  };

  const remove = async () => {
    try {
      await api.delete(uploadUrl);
      toast.success("Logo removida.");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const src = present ? `${API}${serveUrl}?v=${encodeURIComponent(updatedAt)}` : null;

  return (
    <div className="mt-8" data-testid={`${testid}-manager`}>
      <div className="flex items-center gap-2">
        <ImageIcon className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">{title}</h2>
      </div>
      <div className="mt-3 flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-4">
        <div className="flex h-20 w-32 items-center justify-center overflow-hidden rounded-xl bg-[#0b1610]">
          {src ? <img src={src} alt="" className="max-h-full max-w-full object-contain" /> : <span className="text-xs text-slate-400">Sem logo</span>}
        </div>
        <div className="flex gap-2">
          <input ref={fileRef} type="file" accept="image/*" onChange={onFile} className="hidden" data-testid={`${testid}-input`} />
          <Button data-testid={`${testid}-upload`} onClick={() => fileRef.current?.click()} disabled={uploading} className="rounded-xl bg-[#1B7A45] text-white hover:bg-[#156337]">
            <Upload className="mr-1.5 h-4 w-4" /> {uploading ? "Enviando..." : "Enviar logo"}
          </Button>
          {present && (
            <Button data-testid={`${testid}-remove`} onClick={remove} variant="outline" className="rounded-xl border-red-200 bg-red-50 text-red-600 hover:bg-red-100">
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
